<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/time/black</title>
    <g id="atoms/icons/30x30/time/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M15,4 C21.0751322,4 26,8.92486775 26,15 C26,21.0751322 21.0751322,26 15,26 C8.92486775,26 4,21.0751322 4,15 C4,8.92486775 8.92486775,4 15,4 Z M15,6 C10.0294373,6 6,10.0294373 6,15 C6,19.9705627 10.0294373,24 15,24 C19.9705627,24 24,19.9705627 24,15 C24,10.0294373 19.9705627,6 15,6 Z M15,8 C15.5522847,8 16,8.44771525 16,9 L16,14.508 L18.8117567,18.4160042 C19.1094785,18.8298388 19.0454928,19.3941311 18.6812707,19.7321767 L18.5839958,19.8117567 C18.135675,20.1342887 17.5107753,20.0323166 17.1882433,19.5839958 L14.1882433,15.413983 C14.0658485,15.2438537 14,15.039569 14,14.8299872 L14,9 C14,8.44771525 14.4477153,8 15,8 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
